import { render, staticRenderFns } from "./BirthDay.vue?vue&type=template&id=20ff9a13&scoped=true&"
import script from "./BirthDay.vue?vue&type=script&lang=js&"
export * from "./BirthDay.vue?vue&type=script&lang=js&"
import style0 from "./BirthDay.vue?vue&type=style&index=0&id=20ff9a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff9a13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDatePicker,VMenu,VSelect,VSpacer})
